import styled from 'styled-components';
import { rgba } from 'polished';
import KeyboardArrowDown from '@material-ui/icons/KeyboardArrowDown';

// CONSTANTS
import { BLACK, MAIN_BLACK } from '@/constants/colors';

export const AutocompleteWrapper = styled.div`
  position: relative;

  .MuiAutocomplete-option {
    padding: 0;

    &[aria-selected='true'] {
      color: inherit;
    }

    &[aria-selected='true']:not([data-focus='true']) {
      background-color: transparent;
    }
  }
`;

export const ListItem = styled.div`
  position: relative;
  padding-top: 16px;
  padding-right: 5px;
  padding-bottom: 16px;
  padding-left: 30px;
  white-space: normal;
  word-break: break-word;
  color: ${p => (p.selected ? p.theme.palette.primary.main : 'inherit')};
  font-weight: ${p => (p.have ? '700' : 'inherit')};
  width: 100%;

  i {
    display: ${p => (p.selected ? 'initial' : 'none')};
    position: absolute;
    top: 50%;
    left: 15px;
    transform: translate(-50%, -50%);
    font-size: 10px;
  }
`;

export const ChevronIcon = styled(KeyboardArrowDown)`
  width: 1em;
  height: 1em;
  display: inline-block;
  transition: fill 200ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;
  flex-shrink: 0;
  user-select: none;
  fill: ${MAIN_BLACK};
  color: ${rgba(BLACK, 0.54)};
  font-size: 2.4rem;
  pointer-events: none;

  &.is-open {
    transform: rotate(-180deg);
  }
`;

export const AdornmentWrapper = styled.div`
  display: flex;
  align-items: center;
  padding: 0 11px;

  .adornment,
  &.adornment {
    &--small {
      padding-right: 0;

      svg {
        font-size: 1.6rem;
      }
    }
  }
`;

export const NoResults = styled.div`
  color: ${MAIN_BLACK};
  cursor: default;
  overflow: hidden;
  font-size: 1.4rem;
  font-weight: 500;
  line-height: 1.4rem;
`;

export default AutocompleteWrapper;
